import React, { useEffect, useState } from 'react'
import { Button, Form, Input, Select, Checkbox, DatePicker, TimePicker, Radio, Upload, Image } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import moment from 'moment'
import countryCodes from '../../utils/countryCodes'
import { checkSelectOption, clanicData, errorMessage, successMessage, warningMessage } from '../../utils/helpers'
import { POST } from '../../utils/apis'
import { useSelector } from 'react-redux'
import axios from 'axios'

const { Option } = Select
const DoctorFormComponent = (props) => {
    const { onCancel, edit, user, language, selectedLanguage, userActions, roles } = props
    const myServices = useSelector(state => state?.userReducer?.clanicServices)
    const myDoctors = useSelector(state => state?.userReducer?.allDoctorsUser)
    const myServicesData = myServices?.length ? myServices : []
    const myDoctorsData = myDoctors?.length ? myDoctors : []
    const [form] = Form.useForm()
    const [countryCode, setCountryCode] = useState('+31')
    const [laoding, setLoading] = useState(false)
    const [country, setCountry] = useState(edit?.country || 'NL')
    const [fileList, setFileList] = useState([])
    console.log('edit', edit)
    const normFile = (e) => {
        setFileList([])
        if (e?.fileList?.length && e?.file?.type !== 'image/png' && e?.file?.type !== 'image/jpeg') {
            errorMessage('You Can Only Upload Images')
            return []
        }
        if (Array.isArray(e)) {
            return e
        }
        e?.fileList?.length ? setFileList([...[e?.file]]) : setFileList([])
        return e && [e.file]
    }

    const updateCountry = (e) => {
        let selectedCode = countryCodes.filter((v) => v?.code === e)[0].dial_code
        setCountryCode(selectedCode)
        form.setFieldsValue({ prefix: selectedCode })
    }

    const onFinish = async (values) => {
        user?.userType === 'clanic' && (values.clanicId = user?._id)
        values.file = fileList
        if (edit?._id ? false : !values?.file?.length) {
            return warningMessage('Please Upload Logo')
        }
        let formData = new FormData()
        if (values?.file?.length) {
            formData.append('file', values?.file[0])
        }
        delete values.file
        console.log('values', values)
        for (var [k, v] of Object.entries(values)) {
            if (k && v) {
                console.log(k, v)
                if (Array.isArray(v)) {
                    for (let x of v) {
                        formData.append(`${k}[]`, x)
                    }
                } else {
                    formData.append(k, v)
                }
            }
        }
        setLoading(true)
        if (edit?._id) {
            values._id = edit?._id
            axios.post(POST.EDIT_DOCTOR_FROM, values)
                .then(async (res) => {
                    const { data } = res
                    setLoading(false)
                    if (data?.success) {
                        await clanicData.getMyAllDoctors(userActions, user?._id)
                        await onCancel()
                        return successMessage(data?.message)
                    }
                    errorMessage(data?.message)
                })
                .catch((e) => {
                    setLoading(false)
                    errorMessage(e?.message)
                })
        } else {
            axios.post(POST.ADD_DOCTOR, formData)
                .then(async (res) => {
                    const { data } = res
                    setLoading(false)
                    if (data?.success) {
                        await clanicData.getMyAllDoctors(userActions, user?._id)
                        return successMessage(data?.message)
                    }
                    errorMessage(data?.message)
                })
                .catch((e) => {
                    setLoading(false)
                    errorMessage(e?.message)
                })
        }
    }
    const prefixSelector = () => {
        return (
            <Form.Item name='prefix' noStyle>
                <Select
                    showSearch
                    disabled
                    style={{
                        minWidth: 80,
                        maxWidth: window.innerWidth > 500 ? 'auto' : 120,
                    }}
                    defaultValue={countryCode}
                    value={countryCode}
                    filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                >
                    {countryCodes?.map((v, i) => (
                        <Option
                            value={v?.dial_code}
                            key={i}
                        >{`${v?.name} ${v?.dial_code}`}</Option>
                    ))}
                </Select>
            </Form.Item>
        )
    }

    useEffect(() => {
        clanicData.getMyAllDoctors(userActions, user?._id)
        clanicData.getMyAllServices(userActions, user?._id)
    }, [])
    return (
        <div>
            <Form
                name='form'
                onFinish={onFinish}
                layout={'vertical'}
                form={form}
            >
                <div className='form-two-input-flex'>
                    <div className='form-two-input-flex-inner-input'>
                        <Form.Item
                            name={"drName"}
                            label={selectedLanguage?.txt_doctor_name}
                            initialValue={edit?.drName}
                        >
                            <Input
                                className='form-input-new-style' placeholder={selectedLanguage?.txt_doctor_name} />
                        </Form.Item>
                    </div>
                    <div className='form-two-input-flex-inner-input' >
                        <Form.Item
                            name='services'
                            hasFeedback
                            label={<p className='new-pp-colr-wht'>{selectedLanguage?.txt_select_services}</p>}
                            initialValue={edit?.services?.map((v, i) => v?._id)}
                        >
                            <Select
                                mode='multiple'
                                allowClear
                                className='form-input-new-style'
                                placeholder={selectedLanguage?.txt_select_services}
                            >{(myServicesData || [])?.map((v, i) => {
                                return (
                                    <Option value={v?._id}>{v?.serviceName}</Option>
                                )
                            })}
                            </Select>
                        </Form.Item>
                    </div>
                </div>
                <div className='form-two-input-flex-inner-input' style={{ width: '100%' }}>
                    <Form.Item
                        name='email'
                        label={<p className='new-pp-colr-wht'>{selectedLanguage?.input_email_placeholder}</p>}
                        initialValue={edit?.email}
                        hasFeedback
                        rules={[
                            {
                                required: true,
                                message: selectedLanguage?.txt_please_input_your_email,
                            },
                            {
                                type: 'email',
                                message: selectedLanguage?.txt_email_is_not_valid,
                            },
                        ]}
                    >
                        <Input
                            disabled={edit?._id ? true : false}
                            className='form-input-new-style'
                            placeholder={selectedLanguage?.txt_please_input_your_email}
                        />
                    </Form.Item>
                </div>
                <div className='form-two-input-flex'>
                    <div className='form-two-input-flex-inner-input'>
                        <Form.Item
                            name='city'
                            label={<p className='new-pp-colr-wht'>{selectedLanguage?.txt_city}</p>}
                            hasFeedback
                            rules={[
                                {
                                    required: true,
                                    message: selectedLanguage?.txt_please_input_your_city
                                }
                            ]}
                            initialValue={edit?.city}
                        >
                            <Input
                                className='form-input-new-style'
                                placeholder={selectedLanguage?.txt_please_input_your_city}
                            />
                        </Form.Item>
                    </div >
                    <div className='form-two-input-flex-inner-input'>
                        <Form.Item
                            name='country'
                            label={<p className='new-pp-colr-wht'>{selectedLanguage?.txt_country}</p>}
                            hasFeedback
                            initialValue={country}
                            rules={[
                                {
                                    required: true,
                                    message: selectedLanguage?.txt_please_input_your_country
                                }
                            ]}
                        >
                            <Select
                                showSearch
                                showArrow
                                allowClear={false}
                                className='form-input-new-style serchSe'
                                placeholder={selectedLanguage?.txt_please_input_your_country}
                                optionFilterProp='children'
                                onChange={updateCountry}
                                filterOption={checkSelectOption}
                            >
                                {countryCodes?.map((v, i) => <Option value={v?.code} key={i}>{language?.language === 'english' ? v?.name : v?.nameNL}</Option>)}
                            </Select>
                        </Form.Item>
                    </div>
                </div >
                <div className='form-two-input-flex'>
                    <div className='form-two-input-flex-inner-input' >
                        <Form.Item
                            name='telNo'
                            label={<p className='new-pp-colr-wht'>{selectedLanguage?.txt_tel_no}</p>}
                            hasFeedback
                            rules={[
                                {
                                    required: true,
                                    message: selectedLanguage?.txt_please_input_your_tel_no
                                }
                            ]}
                            initialValue={edit?.telNo}
                        >
                            <Input
                                min={0}
                                type='number'
                                pattern='[0-9]*'
                                addonBefore={prefixSelector()}
                                className='form-input-new-style'
                                placeholder={selectedLanguage?.txt_tel_no_example + '-' + `612345678`}
                                onBeforeInput={(e) => {
                                    const inputValue = e.clipboardData?.getData('text') || e.data
                                    if (!/^\d*$/.test(inputValue) || e.target.value.length > 12) {
                                        e.preventDefault()
                                    }
                                }}
                            />
                        </Form.Item>
                    </div >
                    <div className='form-two-input-flex-inner-input' >
                        {edit?._id ?
                            <div>
                                <Image style={{ height: 40, width: 40 }} src={edit?.logoUrl} />
                                <p>{edit?.logo}</p>
                            </div>
                            : <Form.Item
                                name='file'
                                label={<p className='new-pp-colr-wht'>{selectedLanguage?.txt_logo}</p>}
                            >
                                <Upload
                                    name='file'
                                    multiple={false}
                                    beforeUpload={() => false}
                                    accept='image/png, image/jpeg'
                                    onChange={normFile}
                                    fileList={fileList}
                                >
                                    <Button icon={<UploadOutlined />}>{selectedLanguage?.txt_click_to_upload}</Button>
                                </Upload>
                            </Form.Item>}
                    </div>
                </div >
                {edit?._id ? null :
                    <div className='form-two-input-flex'>
                        <div className='form-two-input-flex-inner-input'>
                            <Form.Item
                                name='password'
                                label={<p className='new-pp-colr-wht'>{selectedLanguage?.txt_password}</p>}
                                hasFeedback
                                rules={[
                                    {
                                        required: true,
                                        message: selectedLanguage?.txt_please_input_your_password
                                    },
                                    {
                                        min: 6,
                                        message: selectedLanguage?.txt_password_must_be_atleast_characters
                                    }
                                ]}
                            >
                                <Input.Password
                                    autoComplete="new-password"
                                    className='form-input-new-style'
                                    placeholder={selectedLanguage?.txt_please_input_your_password}
                                />
                            </Form.Item>
                        </div>
                        <div className='form-two-input-flex-inner-input'>
                            <Form.Item
                                label={<p className='new-pp-colr-wht'>{selectedLanguage?.txt_confirm_password}</p>}
                                name='confirm'
                                hasFeedback
                                rules={[
                                    {
                                        required: true,
                                        message: selectedLanguage?.txt_please_input_your_Confirm_password,
                                    },
                                    ({ getFieldValue }) => ({
                                        validator(rule, value) {
                                            if (!value || getFieldValue('password') === value) {
                                                return Promise.resolve()
                                            }
                                            return Promise.reject(
                                                selectedLanguage?.txt_two_passwords_that_you_entered_do_not_match
                                            )
                                        },
                                    }),
                                ]}
                            >
                                <Input.Password
                                    placeholder={selectedLanguage?.txt_please_input_your_Confirm_password}
                                    className='form-input-new-style'
                                />
                            </Form.Item>
                        </div>
                    </div>}
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                    {edit?._id &&
                        <Button
                            style={{ width: '120px', height: '40px' }}
                            type='primary'
                            onClick={onCancel}
                        >
                            {selectedLanguage?.txt_cancel}
                        </Button>}
                    <br />
                    <br />
                    <Form.Item>
                        <Button
                            style={{ width: '120px', height: '40px' }}
                            type='primary'
                            htmlType='submit'
                            laoding={laoding}
                        >
                            {edit?._id ? selectedLanguage?.txt_update : selectedLanguage?.txt_add}
                        </Button>
                    </Form.Item>
                </div>
            </Form >
        </div>
    )
}

export default DoctorFormComponent